"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MultipleNeutral1: ['multiple-neutral-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.375 7.875 A4.125 4.125 0 1 0 11.625 7.875 A4.125 4.125 0 1 0 3.375 7.875 Z', 'M.75,20.25a6.75,6.75,0,0,1,13.5,0', 'M14.251,4.416a4.125,4.125,0,1,1-.006,6.914', 'M15,13.667a6.757,6.757,0,0,1,8.25,6.583']],
  MultipleManWoman2: ['multiple-man-woman-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.251,4.416a4.125,4.125,0,1,1,.756,7.305', 'M15,13.667a6.757,6.757,0,0,1,8.25,6.583', 'M14.248,6.834a6.807,6.807,0,0,0,3.627,1.041,6.843,6.843,0,0,0,2.712-.558', 'M.75,20.25a6.75,6.75,0,0,1,13.5,0', 'M3.388,8.2l-.012.778a5.9,5.9,0,0,1-.859,3.272', 'M11.623,7.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.388,8.2A5.483,5.483,0,0,0,7.5,6.305a5.483,5.483,0,0,0,4.112,1.9', 'M3.375 7.875 A4.125 4.125 0 1 0 11.625 7.875 A4.125 4.125 0 1 0 3.375 7.875 Z']],
  MultipleMan: ['multiple-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,20.25a6.75,6.75,0,0,1,13.5,0', 'M3.945,5.781a6.857,6.857,0,0,0,7.642,1.536', 'M3.375 7.875 A4.125 4.125 0 1 0 11.625 7.875 A4.125 4.125 0 1 0 3.375 7.875 Z', 'M14.251,4.416a4.125,4.125,0,1,1-.006,6.914', 'M15,13.667a6.757,6.757,0,0,1,8.25,6.583', 'M14.248,6.834a6.807,6.807,0,0,0,3.627,1.041,6.843,6.843,0,0,0,2.712-.558']],
  MultipleManWoman1: ['multiple-man-woman-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,20.25a6.75,6.75,0,0,1,13.5,0', 'M3.945,5.781a6.857,6.857,0,0,0,7.642,1.536', 'M3.375 7.875 A4.125 4.125 0 1 0 11.625 7.875 A4.125 4.125 0 1 0 3.375 7.875 Z', 'M15,13.667a6.757,6.757,0,0,1,8.25,6.583', 'M14.251,4.416a4.125,4.125,0,1,1,.756,7.305', 'M20.612,8.2l.011.778a5.9,5.9,0,0,0,.86,3.272', 'M14.247,7.867A5.56,5.56,0,0,0,16.5,6.305a5.483,5.483,0,0,0,4.112,1.9']],
  MultipleUsersNetwork: ['multiple-users-network', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.000 6.750 A6.000 6.000 0 1 0 18.000 6.750 A6.000 6.000 0 1 0 6.000 6.750 Z', 'M6 6.75L18 6.75', 'M9.750 6.750 A2.25 6 0 1 0 14.250 6.750 A2.25 6 0 1 0 9.750 6.750 Z', 'M2.349 16.875 A2.625 2.625 0 1 0 7.599 16.875 A2.625 2.625 0 1 0 2.349 16.875 Z', 'M9.2,23.25a4.474,4.474,0,0,0-8.449,0', 'M16.401 16.875 A2.625 2.625 0 1 0 21.651 16.875 A2.625 2.625 0 1 0 16.401 16.875 Z', 'M23.25,23.25a4.474,4.474,0,0,0-8.449,0']],
  MultipleUsers2: ['multiple-users-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,12a.75.75,0,0,0-.75-.75H6a.75.75,0,0,0-.75.75', 'M1.875 17.625 A2.625 2.625 0 1 0 7.125 17.625 A2.625 2.625 0 1 0 1.875 17.625 Z', 'M8.25,23.25a4.25,4.25,0,0,0-7.5,0', 'M16.875 17.625 A2.625 2.625 0 1 0 22.125 17.625 A2.625 2.625 0 1 0 16.875 17.625 Z', 'M23.25,23.25a4.25,4.25,0,0,0-7.5,0', 'M9.375 3.375 A2.625 2.625 0 1 0 14.625 3.375 A2.625 2.625 0 1 0 9.375 3.375 Z', 'M15.249,8.25a4.269,4.269,0,0,0-6.5,0']],
  MultipleNeutralCircle: ['multiple-neutral-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M4.875 10.875 A4.125 4.125 0 1 0 13.125 10.875 A4.125 4.125 0 1 0 4.875 10.875 Z', 'M6,17.2a6.756,6.756,0,0,1,9.049,3.048', 'M14.999 12.562 A2.813 2.813 0 1 0 20.625 12.562 A2.813 2.813 0 1 0 14.999 12.562 Z']],
  MultipleWoman: ['multiple-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,20.25a6.75,6.75,0,0,1,13.5,0', 'M3.388,8.2l-.012.778a5.9,5.9,0,0,1-.859,3.272', 'M11.612,8.2l.011.778a5.9,5.9,0,0,0,.86,3.272', 'M3.388,8.2A5.483,5.483,0,0,0,7.5,6.305a5.483,5.483,0,0,0,4.112,1.9', 'M3.375 7.875 A4.125 4.125 0 1 0 11.625 7.875 A4.125 4.125 0 1 0 3.375 7.875 Z', 'M15,13.667a6.757,6.757,0,0,1,8.25,6.583', 'M14.251,4.416a4.125,4.125,0,1,1,.756,7.305', 'M20.612,8.2l.011.778a5.9,5.9,0,0,0,.86,3.272', 'M14.247,7.867A5.56,5.56,0,0,0,16.5,6.305a5.483,5.483,0,0,0,4.112,1.9']],
  MultipleUsers1: ['multiple-users-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.125 4.125 A3.375 3.375 0 1 0 14.875 4.125 A3.375 3.375 0 1 0 8.125 4.125 Z', 'M15.553,10.5a6.028,6.028,0,0,0-8.106,0', 'M14.875,4.236A6.752,6.752,0,0,1,13,4.5,6.723,6.723,0,0,1,8.432,2.719', 'M15.125 16.125 A3.375 3.375 0 1 0 21.875 16.125 A3.375 3.375 0 1 0 15.125 16.125 Z', 'M23.25,23.25a6.026,6.026,0,0,0-9.5,0', 'M21.875,16.236a6.76,6.76,0,0,1-6.443-1.517', 'M2.125 16.125 A3.375 3.375 0 1 0 8.875 16.125 A3.375 3.375 0 1 0 2.125 16.125 Z', 'M10.249,23.25a6.026,6.026,0,0,0-9.5,0', 'M8.875,16.236a6.76,6.76,0,0,1-6.443-1.517']],
  MultipleNeutral2: ['multiple-neutral-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.375 7.875 A4.125 4.125 0 1 0 11.625 7.875 A4.125 4.125 0 1 0 3.375 7.875 Z', 'M.75,20.25a6.75,6.75,0,0,1,13.5,0', 'M14.352 10.125 A3.375 3.375 0 1 0 21.102 10.125 A3.375 3.375 0 1 0 14.352 10.125 Z', 'M15.813,15.068A5.526,5.526,0,0,1,23.25,20.25']],
  MultipleUsers3: ['multiple-users-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.375 16.875 A2.625 2.625 0 1 0 14.625 16.875 A2.625 2.625 0 1 0 9.375 16.875 Z', 'M16.224,23.25a4.474,4.474,0,0,0-8.448,0', 'M2.349 3.375 A2.625 2.625 0 1 0 7.599 3.375 A2.625 2.625 0 1 0 2.349 3.375 Z', 'M9.2,9.75a4.474,4.474,0,0,0-8.449,0Z', 'M16.401 3.375 A2.625 2.625 0 1 0 21.651 3.375 A2.625 2.625 0 1 0 16.401 3.375 Z', 'M23.25,9.75a4.474,4.474,0,0,0-8.449,0Z', 'M3.75,12.75V16.5A2.25,2.25,0,0,0,6,18.75h.75', 'M20.25,12.75V16.5A2.25,2.25,0,0,1,18,18.75h-.75']],
  MultipleChat: ['multiple-chat', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,8.25H13.5L12,9.749l-1.5-1.5H2.25a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75h19.5a1.5,1.5,0,0,1,1.5,1.5v4.5A1.5,1.5,0,0,1,21.75,8.25Z', 'M0.750 16.875 A2.625 2.625 0 1 0 6.000 16.875 A2.625 2.625 0 1 0 0.750 16.875 Z', 'M7.514,22.983A4.5,4.5,0,0,0,.75,21.1', 'M18.000 16.875 A2.625 2.625 0 1 0 23.250 16.875 A2.625 2.625 0 1 0 18.000 16.875 Z', 'M16.486,22.983A4.5,4.5,0,0,1,23.25,21.1', 'M8.625 16.125 A3.375 3.375 0 1 0 15.375 16.125 A3.375 3.375 0 1 0 8.625 16.125 Z', 'M16.714,23.249a6.066,6.066,0,0,0-9.429,0']],
  MultipleUsersWifi: ['multiple-users-wifi', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,2.873a9.539,9.539,0,0,0-12,0', 'M8.5,6.488a5.566,5.566,0,0,1,7,0', 'M0.750 13.875 A2.625 2.625 0 1 0 6.000 13.875 A2.625 2.625 0 1 0 0.750 13.875 Z', 'M7.514,19.983A4.5,4.5,0,0,0,.75,18.1', 'M18.000 13.875 A2.625 2.625 0 1 0 23.250 13.875 A2.625 2.625 0 1 0 18.000 13.875 Z', 'M16.486,19.983A4.5,4.5,0,0,1,23.25,18.1', 'M8.625 13.125 A3.375 3.375 0 1 0 15.375 13.125 A3.375 3.375 0 1 0 8.625 13.125 Z', 'M18,23.25a6.054,6.054,0,0,0-12,0']]
};
exports["default"] = _default;